import { useEffect } from "react";
import Loader from "components/Loader";
import Options from "components/Options";
import RadioGroup from "components/RadioGroup";
import useEditions from "hooks/UD/useEditions";

export default function Step1({ params, errors, onChange }) {

   const { d: editions } = useEditions();
   
   // Ustaw domyślną wartość compare_mode jeśli nie jest ustawione
   useEffect(() => {
      if (!params.compare_mode) {
         onChange({ compare_mode: "single" });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
   
   const mode = params.compare_mode || "single";
   const isCompareMode = mode === "compare";
   
   const handleModeChange = (name, value) => {
      // Resetuj wybrane edycje przy zmianie trybu
      onChange({
         compare_mode: value,
         edition: undefined,
         edition2: undefined
      });
   };
   
   const handleEditionChange = (name, value) => {
      onChange(name, value);
   };
   
   return editions ? (
      <>
         <div style={{ marginBottom: "20px" }}>
            <strong style={{ display: "block", marginBottom: "10px" }}>Tryb pracy:</strong>
            <RadioGroup
               name="compare_mode"
               value={mode}
               buttons={[
                  { value: "single", label: "Analiza jednej edycji" },
                  { value: "compare", label: "Porównanie edycji" }
               ]}
               onChange={handleModeChange}
            />
         </div>
         
         {!isCompareMode ? (
            <Options
               name="edition"
               value={ params.edition }
               error={ errors.edition }
               label="Wybierz edycję badania"
               options={ editions || []}
               onChange={ handleEditionChange }
            />
         ) : (
            <>
               <Options
                  name="edition"
                  value={ params.edition }
                  error={ errors.edition }
                  label="Wybierz pierwszą edycję (bazową)"
                  options={ editions || []}
                  onChange={ handleEditionChange }
               />
               <Options
                  name="edition2"
                  value={ params.edition2 }
                  error={ errors.edition2 }
                  label="Wybierz drugą edycję (porównawczą)"
                  options={ editions?.filter(e => e.value !== params.edition) || []}
                  onChange={ handleEditionChange }
               />
               {params.edition && params.edition2 && (
                  <div className="compare-mode-info" style={{ marginTop: "15px", padding: "10px", borderRadius: "4px" }}>
                     <strong>Tryb porównania:</strong> Wybrano dwie edycje. Wyniki będą dotyczyć porównania między nimi.
                  </div>
               )}
            </>
         )}
      </>
   ) : <Loader/>
}